import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SiaSelectBoxComponent, SiaTextBoxComponent } from '@sia/inputs';
import { SiaComponentConfigPerspectives } from '@sia/shared';

@Component({
  selector: 'dialog-overview-example-dialog',
  template: ` <div class="sia-heading" mat-dialog-title>
      Modifica prospettiva
    </div>

    <div mat-dialog-content style="padding: 8px">
      <sia-text-box
        [(value)]="data.description"
        label="Nome della prospettiva*"
        style="font-size: 18px"
      ></sia-text-box>

      <sia-select-box
        [fixedDataSource]="defaultModes"
        [(value)]="data.defaultMode"
        [selectBoxOptions]="{
          fixedDataSource: defaultModes,
          value: data.defaultMode,
        }"
        style="font-size: 18px; padding-top: 8px;"
        label="Default"
      ></sia-select-box>
    </div>
    <div
      mat-dialog-actions
      style="display: flex; justify-content: center; gap: 8px; width : 100%"
    >
      @if (status == 'edit') {
        <button mat-raised-button (click)="onNoClick()" color="warn">
          CHIUDI
        </button>
      }
      @if (status == 'edit') {
        <button mat-raised-button (click)="onSaveClick()" color="primary">
          SALVA
        </button>
      }
    </div>`,
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    SiaTextBoxComponent,
    SiaSelectBoxComponent,
    MatDialogActions,
    MatButton,
  ],
})
export class MatEditPerspectiveDialogComponent {
  dialogRef =
    inject<MatDialogRef<MatEditPerspectiveDialogComponent>>(MatDialogRef);
  data = inject<SiaComponentConfigPerspectives>(MAT_DIALOG_DATA);

  status: string = 'edit';
  oldperspective: SiaComponentConfigPerspectives | undefined;
  defaultModes: { id: string | null; description: string }[] = [
    { id: 'O', description: 'Altro' },
    { id: 'A', description: 'Tutti' },
    { id: 'M', description: 'Mobile' },
    { id: 'D', description: 'Desktop' },
  ];

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSaveClick() {
    this.dialogRef.close(this.data);
  }
}
